import axios from '../utils/axios';

export default function fetchPaidJobsCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/paid-jobs-count', {
            params: params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
